import { listRounds } from '../../action/winners'

export const winnersLoader = async () => {

    await listRounds()

}